/**
* @license Apache-2.0
*
* Copyright (c) 2026 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import Uint64Array from '@stdlib/array-uint64';
import constructorName from '@stdlib/utils-constructor-name';


// MAIN //

/**
* Tests if a value is a Uint64Array.
*
* @param {*} value - value to test
* @returns {boolean} boolean indicating whether value is a Uint64Array
*
* @example
* import Uint64Array from '@stdlib/array-uint64';
*
* var bool = isUint64Array( new Uint64Array( 10 ) );
* // returns true
*
* @example
* var bool = isUint64Array( [] );
* // returns false
*/
function isUint64Array( value ) {
	return (
		value instanceof Uint64Array ||
		constructorName( value ) === 'Uint64Array'
	);
}


// EXPORTS //

export default isUint64Array;
